const badSymbols = ['{', '}', '\\[', ']', '\'', '"', '\\(', '\\)', 'ErrorDetail', '='];

function replaceAll (str, find, replace): string {
  return str.replace(new RegExp(find, 'g'), replace);
}

export default function responseMessageHandler (toasterContent: string): string {
  badSymbols.forEach((symbol) => {
    toasterContent = replaceAll(toasterContent, symbol, ' ');
  });

  if (replaceAll(toasterContent, ' ', '').length > 45) {
    toasterContent = `${toasterContent.slice(0, 50)}...`;
  }

  return toasterContent;
}
